// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__qc6Cr","content":"Hero_content__1wuN3","title":"Hero_title__5gE9l","text":"Hero_text__3m-a8","btnWr":"Hero_btnWr__1SHC4","img":"Hero_img__2-EL7"};